<template>
  <v-card class="align-stretch" height="100%">

    <v-card-title>
      Delivery Address 

      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="openDeliveryAddressDialog"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Line one</p>
          <p><b>{{ deliveryAddress.line_one | customPlaceholder }}</b></p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">County</p>
          <p><b>{{ deliveryAddress.county | customPlaceholder }}</b></p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Line two</p>
          <p><b>{{ deliveryAddress.line_two | customPlaceholder }}</b></p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Postcode</p>
          <p><b>{{ deliveryAddress.post_code | customPlaceholder }}</b></p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">City</p>
          <p><b>{{ deliveryAddress.city | customPlaceholder }}</b></p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Country</p>
          <p><b>{{ deliveryAddress.country | customPlaceholder }}</b></p>
        </v-col>
      </v-row>
    </v-card-text>

    <DeliveryAddressDialog :dialogOpen="deliveryAddressOpen" @close-dialog="deliveryAddressOpen=false" />
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DeliveryAddressDialog from '@/components/Products/ProductTypes/AllProducts/Adhoc/DeliveryAddressDialog';

  export default {
    components: { DeliveryAddressDialog },

    data() {
      return {
        defaultAddress: {
          line_one: '',
          line_two: '',
          city: '',
          county: '',
          post_code: '',
          country: ''
        },
        deliveryAddressOpen: false,
      }
    },

    computed: {
      ...mapGetters('products', ['getCurrentProduct']),

      deliveryAddress() {
        return this.getCurrentProduct.delivery_address ? this.getCurrentProduct.delivery_address : this.defaultAddress;
      }
    },

    methods: {
      openDeliveryAddressDialog() {
        this.deliveryAddressOpen = true;
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>